export default __webpack_public_path__ + "static/media/021-swing.5e7161fd.svg";